import Domen from '../../../stores/Domen';

export const AddAttributesFromFile = async (activeDataset,x) => {
    try {
            var token = localStorage.getItem("token");
            var attr = {
                dataset: activeDataset,
                columnNames: x
            };
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `portraits/table/add_attributes_from_file`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(attr),
            })
            if(response.status=="200"||response.status=="202")
            {
                const data = await response.json();
                location.href = location.href
            }
            else
            {
                alert("Something went wrong, request status:" + response.status)
            }
    } catch (err) {
        console.error("Error in opentablichka:", err);
    }
};
